import React, { useState } from "react";
import { addToCollection } from "../services/database"; // tvoj helper
import uuid from "react-uuid";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: auto;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  background: #fff;
`;

const Title = styled.h2`
  text-align: center;
  color: #333;
  margin-bottom: 20px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Input = styled.input`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  outline: none;
  &:focus {
    border-color: #da2128;
  }
`;

const Textarea = styled.textarea`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
  min-height: 180px;
  outline: none;
  &:focus {
    border-color: #da2128;
  }
`;

const Button = styled.button`
  background: #da2128;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background: #b61b20;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const Loader = styled.div`
  width: 20px;
  height: 20px;
  border: 3px solid white;
  border-top: 3px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const Message = styled.p`
  text-align: center;
  color: ${(p) => (p.error ? "crimson" : "green")};
  font-weight: bold;
  margin-top: 10px;
`;

function parseTopics(topicsRaw) {
  // podržava: "a, b, c" ili više linija
  return (topicsRaw || "")
    .split(/[\n,]/g)
    .map((t) => t.trim())
    .filter(Boolean);
}

// Format po liniji:
// Ime Prezime, email, brojPotvrde, firma (firma opcionalno)
function parseRows(rowsRaw) {
  const lines = (rowsRaw || "")
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean);




  return lines.map((line) => {
    const parts = line.split(",").map((p) => p.trim());
    return {
      name: parts[0] || "",
      email: parts[1] || "",
      certificateNumber: parts[2] || "",
      company: parts[3] || "",
      spol: (parts[4] || "").toLowerCase(),
    };
  });
}

const AddAmlCertificates = () => {
  const [title, setTitle] = useState("NOVI PRAVILNIK O PROVOĐENJU ZAKONA O SPREČAVANJU PRANJA NOVCA I FINANSIRANJA TERORISTIČKIH AKTIVNOSTI");
  const [duration, setDuration] = useState("7 školskih časova");
  const [trainingDate, setTrainingDate] = useState(""); // npr 2026-01-20
  const [issuePlace, setIssuePlace] = useState("Sarajevo");
  const [issueDate, setIssueDate] = useState(""); // npr 2026-01-20

const [topicsRaw, setTopicsRaw] = useState(`Pojašnjenje i tumačenje ključnih odredbi Pravilnika o primjeni Zakona o SPN/FTA
Operacionalizacija zahtjeva Pravilnika u praksi obveznika i usklađivanje internih akata politika i procedura
Rokovi obaveze i odgovornosti obveznika u procesu usklađivanja sa Pravilnikom`);

  const [rowsRaw, setRowsRaw] = useState("");

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

      function formatDateDMY(dateStr) {
  if (!dateStr) return "";
  const [year, month, day] = dateStr.split("-");
  return `${day}.${month}.${year}`;
}


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setErrorMsg("");

    const topics = parseTopics(topicsRaw);
    const rows = parseRows(rowsRaw);

    // Validacija
    const invalid = rows.filter((r) => !r.name || !r.email);
    if (rows.length === 0) {
      setErrorMsg("Nema unosa. Dodaj bar jednu liniju (Ime, email, broj, firma).");
      setLoading(false);
      return;
    }
    if (invalid.length) {
      setErrorMsg("Neki redovi nemaju ime ili email. Provjeri unos.");
      setLoading(false);
      return;
    }

    // Kreiranje dokumenata za bazu
const trainingDateFmt = formatDateDMY(trainingDate);
const issueDateFmt = formatDateDMY(issueDate);

const certificates = rows.map((r) => {
  const id = uuid();
  return {
    id,
    title,
    name: r.name,
    email: r.email,
    company: r.company || "",
    spol: r.spol || "",
    certificateNumber: r.certificateNumber || "",
    duration: duration || "",
    trainingDate: trainingDateFmt,
    issuePlace: issuePlace || "",
    issueDate: issueDateFmt,
    topics,
    createdAt: new Date().toISOString(),
  };
});

    try {
      // 1) upis u bazu
      await Promise.all(
        certificates.map((cert) => addToCollection("aml-certificates", cert.id, cert))
      );

      // 2) slanje emailova (mailer očekuje id/email/name/title)
      const mailPayload = certificates.map((c) => ({
        id: c.id,
        email: c.email,
        name: c.name,
        title: c.title,
      }));

      const resp = await fetch("https://revicon.info/api/send-aml-certificates", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(mailPayload),
      });

      if (!resp.ok) {
        const t = await resp.text().catch(() => "");
        setErrorMsg("Upis u bazu je OK, ali slanje mailova nije uspjelo. " + t);
      } else {
        setMessage(`Uspješno kreirano ${certificates.length} AML potvrda i poslani mailovi.`);
      }
    } catch (err) {
      console.error(err);
      setErrorMsg("Greška prilikom upisa u bazu ili slanja mailova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Title>Import AML potvrda</Title>

      <Form onSubmit={handleSubmit}>
        <Input
          type="text"
          placeholder="Naziv obuke (title)"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />

        <Input
          type="text"
          placeholder="Trajanje (npr. 7 školskih časova)"
          value={duration}
          onChange={(e) => setDuration(e.target.value)}
        />

        <Input
          type="date"
          value={trainingDate}
          onChange={(e) => setTrainingDate(e.target.value)}
          placeholder="Datum obuke"
        />

        <Input
          type="text"
          placeholder="Mjesto izdavanja (npr. Sarajevo)"
          value={issuePlace}
          onChange={(e) => setIssuePlace(e.target.value)}
        />

        <Input
          type="date"
          value={issueDate}
          onChange={(e) => setIssueDate(e.target.value)}
          placeholder="Datum izdavanja"
        />

        <Textarea
          placeholder={`Topics (zarez ili novi red):\nOsnove AML\nProcjena rizika\nInterni postupci`}
          value={topicsRaw}
          onChange={(e) => setTopicsRaw(e.target.value)}
        />

        <Textarea
         placeholder={`Unos po linijama (Ime, email, brojPotvrde, firma opcionalno, spol m/f opcionalno)\nPrimjer:\nArmin Skenderovic, armin@email.com, AML-001, Revicon, m\nAmra Salihovic, amra@email.com, AML-002, Revicon, f`}
          value={rowsRaw}
          onChange={(e) => setRowsRaw(e.target.value)}
          required
        />

        <Button type="submit" disabled={loading}>
          {loading ? <Loader /> : "Upiši u bazu + pošalji mailove"}
        </Button>
      </Form>

      {errorMsg && <Message error>{errorMsg}</Message>}
      {message && <Message>{message}</Message>}
    </Container>
  );
};

export default AddAmlCertificates;
